// The Convex function references, typed from the backend source.
//
// At runtime this is Convex's `anyApi` proxy (what convex/_generated/api.js
// exports too), so the web bundle never imports backend files. The cast gives
// every call site (`api.branches.getBranch`, …) the real argument and return
// types, via a type-only import that is erased at build time.

import { anyApi } from "convex/server"
import type { api as backendApi } from "../../../../convex/_generated/api"

export const api = anyApi as unknown as typeof backendApi
